"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//--- Constants ---//
exports.isMobile = {
    Android: function () {
        return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function () {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function () {
        return ((/iPad|iPhone|iPod/.test(navigator.platform) ||
            (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) &&
            !window.MSStream);
    },
    Opera: function () {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function () {
        return navigator.userAgent.match(/IEMobile/i);
    },
    any: function () {
        return (exports.isMobile.Android() ||
            exports.isMobile.BlackBerry() ||
            exports.isMobile.iOS() ||
            exports.isMobile.Opera() ||
            exports.isMobile.Windows());
    },
};
//export const isChrome = !!(window as IOSWindow).chrome && (!!(window as IOSWindow).chrome.webstore || !!(window as IOSWindow).chrome.runtime);
exports.webkit = window.webkit;
exports.isNativeIOS = window.isNativeIOS;
//--- Functions ---//
function sendToIOS(catagory, payload) {
    var isNativeIOS1 = process.env.NODE_ENV === 'test' ? exports.isNativeIOS : exports.isNativeIOS; // eslint-disable-line no-undef
    var webkit1 = process.env.NODE_ENV === 'test' ? exports.webkit : exports.webkit; // eslint-disable-line no-undef
    if (isNativeIOS1 && webkit1 && webkit1.messageHandlers) {
        //Todo: remove if once native app updates 'params' to 'payload'
        if (catagory === 'onNativeCalled') {
            webkit1.messageHandlers[catagory].postMessage({ params: payload });
        }
        else {
            webkit1.messageHandlers[catagory].postMessage({ payload: payload });
        }
    }
}
exports.sendToIOS = sendToIOS;
// export function sendToAndroid(params:object){
//   if(isMobile.Android()) {
//     window.verifiInterface.verifiID(params);
//   }
// }
